import { render } from "./TeoPlayers.vue?vue&type=template&id=3632e81c"
import script from "./TeoPlayers.vue?vue&type=script&lang=js"
export * from "./TeoPlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__